{
  "id": "meadow_01",
  "name": "Meadow",
  "targetSeconds": 90,
  "spawn": {
    "x": 64,
    "y": 640
  },
  "finishX": 27200,
  "killY": 960,
  "segments": [
    { "type": "ground", "x": 0, "y": 640, "w": 1024, "h": 128 },
    { "type": "checkpoint", "x": 64, "y": 640 },
    { "type": "coin", "x": 992, "y": 544 },
    { "type": "gap", "x": 1024, "w": 96 },
    { "type": "coin", "x": 1056, "y": 544 },
    { "type": "ground", "x": 1120, "y": 640, "w": 1888, "h": 128 },
    { "type": "coin", "x": 1120, "y": 544 },
    { "type": "ramp", "x": 1536, "y": 576, "w": 256, "h": 64, "dir": "up" },
    { "type": "ground", "x": 1792, "y": 576, "w": 256, "h": 64 },
    { "type": "coin", "x": 1792, "y": 512 },
    { "type": "crate", "x": 1856, "y": 512 },
    { "type": "crate", "x": 1920, "y": 512 },
    { "type": "ramp", "x": 2048, "y": 576, "w": 256, "h": 64, "dir": "down" },
    { "type": "coin", "x": 2112, "y": 512 },
    {
      "type": "spike_strip",
      "x": 2624,
      "y": 640,
      "w": 96,
      "periodTicks": 90,
      "activeTicks": 30,
      "phaseTicks": 0
    },
    { "type": "gap", "x": 3008, "w": 128 },
    { "type": "coin", "x": 3008, "y": 528 },
    { "type": "coin", "x": 3072, "y": 528 },
    { "type": "ground", "x": 3136, "y": 640, "w": 2816, "h": 128 },
    { "type": "coin", "x": 3136, "y": 528 },
    {
      "type": "spike_strip",
      "x": 3424,
      "y": 640,
      "w": 128,
      "periodTicks": 90,
      "activeTicks": 30,
      "phaseTicks": 0
    },
    {
      "type": "spike_strip",
      "x": 3840,
      "y": 640,
      "w": 96,
      "periodTicks": 90,
      "activeTicks": 30,
      "phaseTicks": 30
    },
    {
      "type": "spike_strip",
      "x": 4160,
      "y": 640,
      "w": 96,
      "periodTicks": 90,
      "activeTicks": 30,
      "phaseTicks": 60
    },
    { "type": "mud", "x": 4480, "y": 640, "w": 320, "h": 32 },
    { "type": "crate", "x": 4832, "y": 576 },
    { "type": "crate", "x": 4896, "y": 576 },
    { "type": "coin", "x": 4992, "y": 576 },
    { "type": "coin", "x": 5056, "y": 576 },
    { "type": "checkpoint", "x": 5184, "y": 640 },
    {
      "type": "falling_block",
      "x": 5632,
      "y": 320,
      "w": 64,
      "h": 64,
      "dropPx": 256,
      "periodTicks": 120,
      "phaseTicks": 0
    },
    { "type": "gap", "x": 5952, "w": 384 },
    {
      "type": "moving_platform",
      "x": 6080,
      "y": 640,
      "w": 128,
      "h": 32,
      "dx": 0,
      "dy": 64,
      "periodTicks": 90
    },
    { "type": "ground", "x": 6336, "y": 640, "w": 2720, "h": 128 },
    {
      "type": "falling_block",
      "x": 6560,
      "y": 320,
      "w": 64,
      "h": 64,
      "dropPx": 256,
      "periodTicks": 120,
      "phaseTicks": 60
    },
    {
      "type": "swinging_blade",
      "x": 7168,
      "y": 416,
      "lengthPx": 200,
      "amplitudeDeg": 60,
      "periodTicks": 60,
      "phaseTicks": 0
    },
    { "type": "speed_strip", "x": 7552, "y": 640, "w": 64 },
    { "type": "crate", "x": 7808, "y": 576 },
    { "type": "crate", "x": 7872, "y": 576 },
    {
      "type": "moving_platform",
      "x": 8000,
      "y": 544,
      "w": 128,
      "h": 32,
      "dx": 128,
      "dy": 0,
      "periodTicks": 120
    },
    { "type": "coin", "x": 8032, "y": 480 },
    { "type": "coin", "x": 8096, "y": 480 },
    { "type": "coin", "x": 8160, "y": 480 },
    { "type": "coin", "x": 8224, "y": 480 },
    {
      "type": "spike_strip",
      "x": 8576,
      "y": 640,
      "w": 128,
      "periodTicks": 75,
      "activeTicks": 25,
      "phaseTicks": 10
    },
    { "type": "bounce_pad", "x": 8992, "y": 640, "w": 64 },
    { "type": "gap", "x": 9056, "w": 192 },
    { "type": "coin", "x": 9088, "y": 352 },
    { "type": "coin", "x": 9152, "y": 352 },
    { "type": "coin", "x": 9216, "y": 352 },
    { "type": "ground", "x": 9248, "y": 640, "w": 5792, "h": 128 },
    {
      "type": "spike_strip",
      "x": 9632,
      "y": 640,
      "w": 128,
      "periodTicks": 90,
      "activeTicks": 30,
      "phaseTicks": 45
    },
    {
      "type": "spike_strip",
      "x": 10048,
      "y": 640,
      "w": 128,
      "periodTicks": 75,
      "activeTicks": 25,
      "phaseTicks": 40
    },
    { "type": "ramp", "x": 10432, "y": 576, "w": 256, "h": 64, "dir": "up" },
    { "type": "ground", "x": 10688, "y": 576, "w": 256, "h": 64 },
    { "type": "coin", "x": 10688, "y": 512 },
    { "type": "crate", "x": 10752, "y": 512 },
    { "type": "crate", "x": 10816, "y": 512 },
    { "type": "coin", "x": 10880, "y": 512 },
    { "type": "ramp", "x": 10944, "y": 576, "w": 256, "h": 64, "dir": "down" },
    { "type": "checkpoint", "x": 11264, "y": 640 },
    {
      "type": "swinging_blade",
      "x": 11904,
      "y": 416,
      "lengthPx": 200,
      "amplitudeDeg": 60,
      "periodTicks": 66,
      "phaseTicks": 20
    },
    { "type": "crumbling_platform", "x": 12256, "y": 544, "w": 160, "h": 32 },
    { "type": "coin", "x": 12288, "y": 480 },
    {
      "type": "spike_strip",
      "x": 12320,
      "y": 640,
      "w": 256,
      "periodTicks": 90,
      "activeTicks": 24,
      "phaseTicks": 0
    },
    { "type": "coin", "x": 12384, "y": 480 },
    { "type": "crumbling_platform", "x": 12416, "y": 544, "w": 160, "h": 32 },
    { "type": "coin", "x": 12480, "y": 480 },
    {
      "type": "falling_block",
      "x": 12928,
      "y": 320,
      "w": 64,
      "h": 64,
      "dropPx": 256,
      "periodTicks": 120,
      "phaseTicks": 30
    },
    {
      "type": "falling_block",
      "x": 13248,
      "y": 320,
      "w": 64,
      "h": 64,
      "dropPx": 256,
      "periodTicks": 120,
      "phaseTicks": 90
    },
    { "type": "mud", "x": 13568, "y": 640, "w": 384, "h": 32 },
    { "type": "crate", "x": 13696, "y": 576 },
    { "type": "crate", "x": 13760, "y": 576 },
    { "type": "coin", "x": 14080, "y": 576 },
    { "type": "coin", "x": 14144, "y": 576 },
    { "type": "coin", "x": 14208, "y": 576 },
    {
      "type": "spike_strip",
      "x": 14656,
      "y": 640,
      "w": 96,
      "periodTicks": 90,
      "activeTicks": 30,
      "phaseTicks": 15
    },
    { "type": "gap", "x": 15040, "w": 576 },
    {
      "type": "moving_platform",
      "x": 15168,
      "y": 608,
      "w": 128,
      "h": 32,
      "dx": 0,
      "dy": 64,
      "periodTicks": 80
    },
    { "type": "coin", "x": 15200, "y": 512 },
    {
      "type": "moving_platform",
      "x": 15424,
      "y": 640,
      "w": 128,
      "h": 32,
      "dx": 0,
      "dy": -64,
      "periodTicks": 80
    },
    { "type": "coin", "x": 15456, "y": 512 },
    { "type": "ground", "x": 15616, "y": 640, "w": 320, "h": 128 },
    { "type": "gap", "x": 15936, "w": 160 },
    { "type": "coin", "x": 15968, "y": 528 },
    { "type": "coin", "x": 16032, "y": 528 },
    { "type": "ground", "x": 16096, "y": 640, "w": 1760, "h": 128 },
    {
      "type": "spike_strip",
      "x": 16288,
      "y": 640,
      "w": 96,
      "periodTicks": 90,
      "activeTicks": 30,
      "phaseTicks": 45
    },
    { "type": "crate", "x": 16640, "y": 576 },
    { "type": "crate", "x": 16704, "y": 576 },
    { "type": "coin", "x": 16896, "y": 576 },
    { "type": "coin", "x": 16960, "y": 576 },
    { "type": "coin", "x": 17024, "y": 576 },
    { "type": "checkpoint", "x": 17152, "y": 640 },
    { "type": "speed_strip", "x": 17664, "y": 640, "w": 128 },
    { "type": "gap", "x": 17856, "w": 224 },
    { "type": "coin", "x": 17888, "y": 512 },
    { "type": "coin", "x": 17952, "y": 512 },
    { "type": "coin", "x": 18016, "y": 512 },
    { "type": "ground", "x": 18080, "y": 640, "w": 3040, "h": 128 },
    {
      "type": "spike_strip",
      "x": 18304,
      "y": 640,
      "w": 128,
      "periodTicks": 90,
      "activeTicks": 30,
      "phaseTicks": 15
    },
    {
      "type": "falling_block",
      "x": 18752,
      "y": 320,
      "w": 64,
      "h": 64,
      "dropPx": 256,
      "periodTicks": 120,
      "phaseTicks": 0
    },
    {
      "type": "falling_block",
      "x": 18880,
      "y": 320,
      "w": 64,
      "h": 64,
      "dropPx": 256,
      "periodTicks": 120,
      "phaseTicks": 45
    },
    {
      "type": "swinging_blade",
      "x": 19264,
      "y": 416,
      "lengthPx": 200,
      "amplitudeDeg": 50,
      "periodTicks": 60,
      "phaseTicks": 10
    },
    { "type": "crate", "x": 19712, "y": 576 },
    { "type": "crate", "x": 19776, "y": 576 },
    { "type": "ramp", "x": 19840, "y": 576, "w": 256, "h": 64, "dir": "up" },
    { "type": "ground", "x": 20096, "y": 576, "w": 256, "h": 64 },
    { "type": "coin", "x": 20160, "y": 512 },
    { "type": "coin", "x": 20224, "y": 512 },
    { "type": "ramp", "x": 20352, "y": 576, "w": 256, "h": 64, "dir": "down" },
    {
      "type": "spike_strip",
      "x": 20736,
      "y": 640,
      "w": 128,
      "periodTicks": 75,
      "activeTicks": 25,
      "phaseTicks": 30
    },
    { "type": "gap", "x": 21120, "w": 128 },
    { "type": "coin", "x": 21120, "y": 528 },
    { "type": "coin", "x": 21184, "y": 528 },
    { "type": "ground", "x": 21248, "y": 640, "w": 8192, "h": 128 },
    {
      "type": "swinging_blade",
      "x": 21568,
      "y": 416,
      "lengthPx": 200,
      "amplitudeDeg": 60,
      "periodTicks": 54,
      "phaseTicks": 0
    },
    {
      "type": "spike_strip",
      "x": 21984,
      "y": 640,
      "w": 128,
      "periodTicks": 90,
      "activeTicks": 30,
      "phaseTicks": 60
    },
    {
      "type": "falling_block",
      "x": 22336,
      "y": 320,
      "w": 64,
      "h": 64,
      "dropPx": 256,
      "periodTicks": 120,
      "phaseTicks": 60
    },
    { "type": "checkpoint", "x": 22784, "y": 640 },
    { "type": "crate", "x": 23232, "y": 576 },
    { "type": "crate", "x": 23296, "y": 576 },
    { "type": "speed_strip", "x": 24000, "y": 640, "w": 96 },
    { "type": "coin", "x": 24576, "y": 576 },
    { "type": "coin", "x": 24640, "y": 576 },
    { "type": "coin", "x": 24704, "y": 576 },
    { "type": "speed_strip", "x": 25280, "y": 640, "w": 96 },
    { "type": "crate", "x": 25984, "y": 576 },
    { "type": "crate", "x": 26048, "y": 576 },
    { "type": "speed_strip", "x": 26560, "y": 640, "w": 96 },
    { "type": "coin", "x": 26880, "y": 576 },
    { "type": "coin", "x": 26944, "y": 576 }
  ]
}
